module.exports = __webpack_public_path__ + "static/cs-hc-slider-img-1-42491fbccde180ceff720b60e33297df.jpg";